export default class NtakErrorLogList {

	constructor (data) {
		this.data = data
	}

	static async fetch (db_name) {

		const data = await Anvil.REST.get(`/c_order/terminal/fetch_ntak_errors/${db_name}`)

		return new NtakErrorLogList(data.bad_reports)
	}
}
